export const CHART_COLOR = '#25313F';
export const PLOT_COLOR = '#1E2834';
export const OUT_COLOR = '#808896';
export const GRID_LINE_COLOR = '#1A232D';
export const LEGEND_COLOR = OUT_COLOR;
export const LEGEND_HOVER_COLOR = '#333333';
export const LEGEND_HIDDEN_COLOR = '#FFFFFF';

export const DEFAULT_CHART_OPTIONS = {
  chart: {
    backgroundColor: CHART_COLOR,
    plotBackgroundColor: PLOT_COLOR,
    animation: false
  },
  credits: {
    enabled: false
  },
  title: false,
  plotOptions: {
    series: {
      marker: {
        symbol: 'circle'
      }
    },
    area: {
      animation: false
    }
  },
  xAxis: {
    gridLineColor: GRID_LINE_COLOR,
    lineColor: OUT_COLOR,
    tickColor: OUT_COLOR,
    labels: {
      rotation: false,
      style: {
        color: OUT_COLOR,
        fontWeight: 'bold'
      }
    },
    maxPadding: 0,
    minPadding: 0
  },
  yAxis: {
    gridLineColor: GRID_LINE_COLOR,
    lineColor: OUT_COLOR,
    tickColor: OUT_COLOR,
    labels: {
      style: {
        color: OUT_COLOR,
        fontWeight: 'bold'
      }
    }
  },
  legend: {
    itemStyle: {
      color: LEGEND_COLOR
    },
    itemHiddenStyle: {
      color: LEGEND_HIDDEN_COLOR
    },
    itemHoverStyle: {
      color: LEGEND_HOVER_COLOR
    }
  }
};



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/shared/components/charts/chart.constants.ts